import * as Sentry from "@sentry/react";
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from '@react-oauth/google';
import {
  detectBrowser,
  detectMobilePlatform,
  isSafari,
  isFirefox,
  isChrome,
  isEdge,
  isAndroid,
  isIOS,
  isIPhone,
  isIPad,
  isIPod,
  isMobileDevice,
  isTabletDevice,
  getBrowserName,
  getMobilePlatformName,
  isMobileBrowser,
  getLocalIPAddress,
  getExternalIPAddress,
  getIPAddresses
} from './utils';

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  // Explicit REACT_APP_SENTRY_ENV wins so the v2/Render build tags itself distinctly
  // (e.g. "v2-render") apart from the Moveo v1 "production" errors in the same project.
  environment: process.env.REACT_APP_SENTRY_ENV
    || (process.env.REACT_APP_DOMAIN?.includes("localhost")
      ? "local"
      : process.env.REACT_APP_DOMAIN?.includes("develop.")
        ? "develop"
        : "production"),
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 0.2,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,
});

// Make detection functions globally available for console testing
if (typeof window !== 'undefined') {
  window.detectBrowser = detectBrowser;
  window.detectMobilePlatform = detectMobilePlatform;
  window.isSafari = isSafari;
  window.isFirefox = isFirefox;
  window.isChrome = isChrome;
  window.isEdge = isEdge;
  window.isAndroid = isAndroid;
  window.isIOS = isIOS;
  window.isIPhone = isIPhone;
  window.isIPad = isIPad;
  window.isIPod = isIPod;
  window.isMobileDevice = isMobileDevice;
  window.isTabletDevice = isTabletDevice;
  window.getBrowserName = getBrowserName;
  window.getMobilePlatformName = getMobilePlatformName;
  window.isMobileBrowser = isMobileBrowser;
  
  // Make IP detection functions globally available
  window.getLocalIPAddress = getLocalIPAddress;
  window.getExternalIPAddress = getExternalIPAddress;
  window.getIPAddresses = getIPAddresses;
  
  // Log available functions in development
  if (process.env.NODE_ENV === 'development') {
    console.log('🔍 Device Detection Functions Available:');
    console.log('  - detectBrowser()');
    console.log('  - detectMobilePlatform()'); 
    console.log('  - Quick checks: isIOS(), isAndroid(), isIPhone(), isIPad(), etc.');
    console.log('  - IP detection: getLocalIPAddress(), getExternalIPAddress(), getIPAddresses()');
    console.log('  - Try: getLocalIPAddress().then(ip => console.log("Local IP:", ip))');
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<p>Something went wrong.</p>}>
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || ''}>
        <App />
      </GoogleOAuthProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
